var _defs, _polygon, _rect, _rect2, _polygon2, _rect3, _rect4, _path, _path2, _path3, _polygon3, _rect5, _rect6, _polygon4, _rect7, _rect8, _path4, _image, _polygon5, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEsign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 650 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}.cls-16{fill:url(#linear-gradient-16);}.cls-17{fill:#f5f3f5;}.cls-18{fill:url(#linear-gradient-17);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 301.14,
    y1: 207.43,
    x2: 301.14,
    y2: 350.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f3f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 310.41,
    y1: 345.72,
    x2: 336.02,
    y2: 345.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#f5f3f5",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f5f3f5",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#f5f3f5",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 423.3,
    y1: 345.72,
    x2: 412.86,
    y2: 345.72,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 428.51,
    y1: 207.43,
    x2: 428.51,
    y2: 350.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 422.43,
    y1: 211.87,
    x2: 394.22,
    y2: 211.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f5f3f5",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#f5f3f5",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f5f3f5",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#f5f3f5",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f5f3f5",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 302.95,
    y1: 211.87,
    x2: 327.77,
    y2: 211.87,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 360.92,
    y1: 207.48,
    x2: 360.92,
    y2: 283.3,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 313.49,
    y1: 90.24,
    x2: 313.49,
    y2: 172.97,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 313.49,
    y1: 105.22,
    x2: 313.49,
    y2: 141.82,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 239.49,
    y1: 147.24,
    x2: 239.49,
    y2: 381.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f3f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 263.56,
    y1: 376.86,
    x2: 332.23,
    y2: 376.86,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 407.14,
    y1: 172.12,
    x2: 407.14,
    y2: 205.52,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 404.24,
    y1: 147.24,
    x2: 404.24,
    y2: 173.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 396.9,
    y1: 151.67,
    x2: 378.91,
    y2: 151.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 229.95,
    y1: 151.67,
    x2: 246.82,
    y2: 151.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 374.15,
    y1: 329.85,
    x2: 374.15,
    y2: 409.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f5f3f5",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#f5f3f5",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#f5f3f5",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -2096.95,
    y1: -467.86,
    x2: -2063.35,
    y2: -467.86,
    gradientTransform: "translate(2463.39 835.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#f5f3f5",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#f5f3f5",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f5f3f5",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#f5f3f5",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f5f3f5",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#f5f3f5",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "310.41 350.15 291.87 350.15 291.87 207.43 302.94 207.43 302.94 216.3 300.74 216.3 300.74 341.28 310.41 341.28 310.41 350.15"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 310.41,
    y: 341.28,
    width: 25.61,
    height: 8.87
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 412.86,
    y: 341.28,
    width: 10.44,
    height: 8.87
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "434.59 350.15 423.3 350.15 423.3 341.28 425.72 341.28 425.72 216.3 422.43 216.3 422.43 207.43 434.59 207.43 434.59 350.15"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 394.22,
    y: 207.43,
    width: 28.21,
    height: 8.87
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 302.95,
    y: 207.43,
    width: 24.82,
    height: 8.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M392.74,283.3l-31.82-22.59L329.1,283.3V207.48h63.64Zm-54.77-67v49.78l22.95-16.3,22.95,16.3V216.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M374.12,173H252.87v-9.39a44.43,44.43,0,0,1,27.36-41.07,33.28,33.28,0,0,1,66.53,0,44.43,44.43,0,0,1,27.36,41.07ZM261.73,164.1H365.25v-.52a35.57,35.57,0,0,0-24.41-33.81l-3.26-1.09.25-3.71c0-.48.08-1,.08-1.45a24.42,24.42,0,0,0-48.83,0c0,.5,0,1,.08,1.49l.26,3.67-3.27,1.09a35.56,35.56,0,0,0-24.42,33.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M313.49,141.82a18.3,18.3,0,1,1,18.3-18.3A18.32,18.32,0,0,1,313.49,141.82Zm0-27.73a9.43,9.43,0,1,0,9.44,9.43A9.44,9.44,0,0,0,313.49,114.09Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "263.56 381.29 215.41 381.29 215.41 147.24 229.95 147.24 229.95 156.11 224.28 156.11 224.28 372.42 263.56 372.42 263.56 381.29"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 263.56,
    y: 372.42,
    width: 68.66,
    height: 8.87
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 402.7,
    y: 172.12,
    width: 8.87,
    height: 33.4
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "411.57 173.74 402.7 173.74 402.7 156.11 396.9 156.11 396.9 147.24 411.57 147.24 411.57 173.74"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 378.91,
    y: 147.24,
    width: 17.99,
    height: 8.87
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 229.95,
    y: 147.24,
    width: 16.86,
    height: 8.87
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M374.15,409.76a40,40,0,1,1,40-39.95A40,40,0,0,1,374.15,409.76Zm0-71a31.09,31.09,0,1,0,31.08,31.09A31.13,31.13,0,0,0,374.15,338.72Z"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 78,
    height: 79,
    transform: "translate(350 364.96) scale(0.24)",
    xlinkHref: "data:image/png;base64,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"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "368.21 389.51 361.75 383.05 368.02 376.78 368.21 376.97 368.34 376.84 374.62 383.11 368.21 389.51"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 366.4,
    y: 363.82,
    width: 33.59,
    height: 8.87,
    transform: "translate(-148.16 378.78) rotate(-45)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsign);
export default __webpack_public_path__ + "static/media/esign.ab053ea5edb5e754d6a29fd2529f7140.svg";
export { ForwardRef as ReactComponent };